<template>
  <div style="position: relative;">
    <template v-if="pageLoaded">
      <Header :hasHeaderLine="hasHeaderLine" />
      <currencies />
      <template v-if="category">
        <div class="container pc" v-if="articles.desktop">
          <template v-for="n in currentPage * 3">
            <template v-if="articles.desktop[n]">
              <cards-section :key="'journal-rows_' + n" :code="category" :items="articles.desktop[n]"
                v-if="articles.desktop[n]" />
            </template>
          </template>
          <div v-observe-visibility="handleScrolledToBottom"></div>
          <div class="loader-wrapper" v-if="showLoader">
            <img src="@/assets/img/circle-loader.svg" class="circle-loader">
          </div>
        </div>
        <div class="container phone">
          <template v-for="n in currentPage * 4">
            <template v-if="articles.mobile[n]">
              <div :key="'extra-mobile-card' + n" v-if="articles.mobile[n]">
                <ArticleCardMobile v-if="articles.mobile[n]" :article="articles.mobile[n]" />
              </div>
            </template>
          </template>
          <div v-observe-visibility="handleScrolledToBottom"></div>
          <div class="loader-wrapper" v-if="showLoader">
            <img src="@/assets/img/circle-loader.svg" class="circle-loader">
          </div>
        </div>
      </template>
      <SocialBanner />
      <Footer />
    </template>
  </div>
</template>

<script>
import request from '@/api/axios';
import CardsSection from '../CardsSectionNewCopy';
import Header from '@/components/newRedesign/HeaderNewCopy';
import Footer from '@/components/newRedesign/FooterNewCopy';
// import Banner from './Banner';
import Currencies from '@/components/redesign/Currencies';
import SocialBanner from '@/components/newRedesign/UI/SocialBanner.vue';
import ArticleCardMobile from '@/components/newRedesign/UI/ArticleCardMobile.vue';
import $ from 'jquery'

export default {
  data: () => {
    return {
      data: {},
      pageLoaded: false,
      currentPage: 1,
      showLoader: false,
      articles: {},
      activeMonth: '',
      category: null,
      hasHeaderLine: true,
      slickOptionsMainSlider: {
        arrows: true,
        autoplay: false,
        autoplaySpeed: 3000,
        dots: true,
        dotsClass: 'slide-header-dots',
        centerMode: true,
        touchThreshold: 10,
        centerPadding: '16px',
        variableWidth: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        infinite: true,
        responsive: [{
          breakpoint: 576,
          settings: {
            arrows: false,
            centerPadding: '16px',
            slidesToShow: 1,
            variableWidth: false
          }
        }]
      },
      slickOptionsCards: {
        arrows: false,
        dots: false,
        slidesToShow: 1,
        touchThreshold: 10,
        slidesToScroll: 1,
        variableWidth: true
      },
      slickOptionsMoney: {
        arrows: false,
        dots: false,
        infinite: true,
        slidesToShow: 4,
        touchThreshold: 10,
        slidesToScroll: 1,
        responsive: [{
          breakpoint: 576,
          settings: {
            slidesToShow: 1,
            swipeToSlide: true
          }
        }]
      },
      templates: {
        4: 'simple',
        5: 'emoji',
        6: 'double',
        7: 'image',
        8: 'list',
        9: 'quote',
        11: 'number'
      },
      templatesWeight: {
        double: 2,
        list: 0.3
      }
    }
  },
  head: {
    link: function () {
      return [
        {
          rel: 'canonical',
          href: ('https://finsite.me/' + (this.$route.params.code ? 'category/' + this.$route.params.code : ''))
        }
      ]
    }
  },
  components: {
    CardsSection,
    Header,
    Footer,
    Currencies,
    SocialBanner,
    ArticleCardMobile
  },
  watch: {
    $route(to, from) {
      if (to.path && to.path.indexOf('/category/') > -1) {
        this.setCategory(to.path.replace('/category/', ''));
      } else {
        this.setCategory(null);
      }
    }
  },
  computed: {
    user() {
      return this.$store.state.user;
    }
  },
  async created() {
    this.pageLoaded = false;

    this.data = await this.getArticles();
    this.data.articles = this.data.articles.map(item => {
      item.categoryData = this.data.categories.find(category => category.id === item.category);
      item.url = '/article' + item.url;
      item.template = this.templates[item.template];
      item.original_name = item.name;
      item.name = item.card_name || item.name;
      item.image = this.$config.hostname + item.image;
      return item;
    });

    if (this.$route.params.code) {
      this.setCategory(this.$route.params.code);
    } else {
      this.setCategory(null);
    }
  },
  mounted() {

  },
  methods: {
    tgScript() {
      this.$nextTick(() => {
        $(document).ready(function () {
          const $el = window.matchMedia('(min-width: 599px)').matches ? $('.pc .footer') : $('.phone .footer');
          $(window).scroll(function () {
            const hT = $el.offset().top,
              hH = $el.outerHeight(),
              wH = $(window).height(),
              wS = $(this).scrollTop();

            if (wS > (hT + hH - wH) - 300) {
              $('.tg-floatted-button').addClass('absolute');
            } else {
              $('.tg-floatted-button').removeClass('absolute');
            }
          });
        });
      });
    },
    async onLoad() {
      this.pageLoaded = false;

      if (!this.category) {
        const special = this.data?.articles?.slice(0, 3);
        const simple = this.data?.articles?.slice(3);
        const feed = this.data?.articles?.slice(3, 11);
        const simpleMobile = this.data?.articles?.slice(11);
        this.activeMonth = this.data?.activeMonth;

        this.articles = {
          desktop: {
            lifeHacks: simple.filter(item => item.categoryData.code === 'lifehacks'),
            knowledge: simple.filter(item => item.categoryData.code === 'knowledge'),
            test: simple.filter(item => item.categoryData.code === 'test'),
            reviews: simple.filter(item => item.categoryData.code === 'reviews'),
            gold: simple.filter(item => item.gold)
          },
          mobile: {
            feed: feed,
            lifeHacks: simpleMobile.filter(item => item.categoryData.code === 'lifehacks'),
            knowledge: simpleMobile.filter(item => item.categoryData.code === 'knowledge'),
            test: simpleMobile.filter(item => item.categoryData.code === 'test'),
            reviews: simpleMobile.filter(item => item.categoryData.code === 'reviews'),
            gold: simpleMobile.filter(item => item.gold)
          },
          special: special,
          month: this.data?.month,
        };
      } else {
        this.activeMonth = this.data?.activeMonth;

        const articles = this.data?.articles?.filter(item => item.categoryData.code === this.category);

        this.articles = {
          mobile: articles,
          desktop: this.getArticlesForRows(articles.map(item => {
            if (item.template === 'list') item.template = 'simple';
            return item;
          })),
          month: this.data?.month,
        };
      }

      window.scrollTo(0, 0);
      this.pageLoaded = true;
      this.tgScript();
    },
    getArticlesForRows(articles) {
      if (!articles) return [];
      let weight = 0;
      let curIndex = 0;
      return articles.reduce((acc, item) => {
        weight += (this.templatesWeight[item.template] || 1);
        if (weight > 4) {
          weight = (this.templatesWeight[item.template] || 1);
          curIndex++;
        }
        if (!acc[curIndex]) acc[curIndex] = [];
        acc[curIndex].push(item);
        return acc;
      }, []);
    },
    setCategory(code) {
      this.category = code;
      if (code === null) {
        this.category = null;
      } else {
        this.category = code;
      }
      this.onLoad();
    },
    async getArticles() {
      return (await request({ action: 'get_articles' })).data;
    },
    monthChange(id) {
      this.activeMonth = id;
      this.$nextTick(function () {
        this.$refs['slickMoney_' + id][0].reSlick();
      });
    },
    handleScrolledToBottom(isVisible) {
      if (!isVisible) { return }
      if (this.currentPage >= this.lastPage) { return }
      this.showLoader = true
      this.currentPage++
      this.showLoader = false
    }
  }
}
</script>
<style scoped>
.new-journal .row.row-full-width.store {
  margin-left: 8px;
  margin-right: 8px;
}
</style>
